import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string | null;
  social_meta_description: string | null;
  content: string | null;
  category: string;
  read_time: string | null;
  featured: boolean | null;
  published: boolean | null;
  featured_image: string | null;
  tags: string[] | null;
  display_order: number | null;
  created_at: string;
  updated_at: string;
}

export function useBlogPosts() {
  return useQuery({
    queryKey: ["blog-posts"],
    queryFn: async () => {
      // Try featured posts first
      const { data: featured, error: featuredError } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("published", true)
        .eq("featured", true)
        .order("display_order", { ascending: true })
        .limit(3);

      if (featuredError) throw featuredError;

      if (featured && featured.length > 0) {
        return featured as BlogPost[];
      }

      // Fallback to most recent published posts
      const { data: recent, error: recentError } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("published", true)
        .order("created_at", { ascending: false })
        .limit(3);

      if (recentError) throw recentError;
      return (recent ?? []) as BlogPost[];
    },
  });
}
